import DOMPurify from 'dompurify';

export const sleep = (time: number) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const phoneRegex =
  /^(?:(0))(?:(70|80|81|90|91|80|92|93|94|95|96|97|98|99)\d{8})$/;

  export const extractTextFromHTML = (html: any) => {
    // Sanitize the HTML content
    const sanitizedHTML = DOMPurify.sanitize(html);
  
    // Parse HTML and extract text
    const parser = new DOMParser();
    const doc = parser.parseFromString(sanitizedHTML, 'text/html');
    return doc.body.textContent || '';
  };

  export const truncateTextByCharacters = (
    text: string,
    charLimit: number
  ): string => {
    if (!text) {
      return text;
    }
    if (text?.length <= charLimit) {
      return text; // If the text length is within the limit, return as is
    }
    return text?.slice(0, charLimit) + '...'; // Truncate and append '...'
  };
  
  // truncate text
  export const truncateText = (text: string, wordLimit = 10) => {
    const words = text.split(/\s+/); // Split text into words
    if (words.length <= wordLimit) {
      return text; // If text has 20 words or fewer, return the original text
    }
    return words.slice(0, wordLimit).join(' ') + '...'; // Join the first 9 words and append '...'
  };
